import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Button from '@package/components/Button';
import Icon from '@package/components/Icon';
import { getBreadcrumbs } from '@plone/volto/actions/breadcrumbs/breadcrumbs';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';

const messages = defineMessages({
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  breadcrumbs: {
    id: 'Breadcrumbs',
    defaultMessage: 'Breadcrumbs',
  },
  controlpanel: {
    id: 'Site Setup',
    defaultMessage: 'Site Setup',
  },
});

const Breadcrumbs = ({ pathname }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { pathname: realPath } = useLocation();
  const controlpanelItems = [
    {
      url: '/controlpanel',
      title: intl.formatMessage(messages.controlpanel),
    },
  ];

  const items = useSelector(
    (state) =>
      realPath.startsWith('/controlpanel')
        ? controlpanelItems
        : state.breadcrumbs.items,
    shallowEqual,
  );

  const root = useSelector((state) => state.breadcrumbs.root);

  useEffect(() => {
    if (!hasApiExpander('breadcrumbs', getBaseUrl(pathname))) {
      dispatch(getBreadcrumbs(getBaseUrl(pathname)));
    }
  }, [dispatch, pathname]);

  if (items.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumbs">
      <Button href={root || '/'} link xsmall>
        {intl.formatMessage(messages.home)}
      </Button>
      {items.map((item, index, items) => [
        <span className="arrow" key={`divider-${item.url}`}>
          <Icon name="chevron_right" className="arrow-icon" />
        </span>,
        index < items.length - 1 ? (
          <Button
            xsmall
            link
            key={item.url}
            href={item.url}
            // className="section"
          >
            {item.title}
          </Button>
        ) : (
          <span key={item.url} className="current">
            {item.title}
          </span>
        ),
      ])}
    </nav>
  );
};

Breadcrumbs.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default Breadcrumbs;
